<div class="modal-header w-100 d-inline-block p-3 pb-0 mb-0 bg-white" >
    <div *ngIf="!showNextDisplay">
      <div class="header d-flex justify-content-between align-items-center">
          <h3>Contact Support</h3>
          <fa-icon [icon]="icons.cancel"  (click)="bsModalRef?.hide()"    class="icon"></fa-icon>
      </div>
      <div class="content">
      <p class="my-3">Our team are available on the go to assist & support with any challenge.</p>
      <div class="contact p-4">
          <div>
              <span class="fw-bold">Contact Info</span>
              <div class="d-flex justify-space-between mt-4">
                <fa-icon [icon]="icons.address"></fa-icon>
                <p class="ml-5">20-22 Wenlock Rd, London N1 7GU,
                  United Kingdom</p>
              </div>
              <div class="d-flex justify-space-between">
                <fa-icon [icon]="icons.phone"></fa-icon>
                <p class="ml-5"> +443330905478</p>
              </div>
              <div class="d-flex justify-space-between">
                <fa-icon [icon]="icons.mail"></fa-icon>
                <p class="ml-5">info@clooper.com</p>
              </div>
          </div>
      </div>
      <div class="form" >
          <p>Send us a direct message</p>
          <form [formGroup]="contactForm">
          <label for="title">Title</label>
          <input type="text" id="title" placeholder="Title of Message" formControlName="title">
          <label for="message">Message</label>
          <textarea name="" id="message" placeholder="Type your message" formControlName="message"></textarea>
          <button (click)="submit()" type="submit" class="btn" [disabled]="contactForm.invalid"> {{loading ? 'Submitting...' :'Send Message'}} </button>
          </form>
      </div>
    </div>
    </div>
    <div *ngIf="showNextDisplay" class="p-4 text-center">
      <div class="text-right w-100" ><fa-icon [icon]="icons.cancel" (click)="bsModalRef?.hide()"    class="icon"></fa-icon></div>
      <img src="assets/images/Success.gif" class="success">
      <h1>Request Sent!</h1>
      <p class="mb-5">Your booking cancellation request has
        been sent. Our support team would get in touch shortly.
      </p>
      <div class="mb-4 d-flex  gap-3 resend">
        <button class="btn btn-resend w-100 " (click)="bsModalRef?.hide()">Done</button>
      </div>
    </div>
</div>
